var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLoginPassHiddenSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon login-pass hidden",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.707 2.293a1 1 0 010 1.414l-14 14a1 1 0 01-1.414-1.414l14-14a1 1 0 011.414 0zM16.58 6.249c1.198.875 2.296 1.982 3.265 3.277a.804.804 0 010 .952C17.286 13.896 13.82 16 10 16c-.955 0-1.887-.131-2.789-.382l1.754-1.754c.41.11.846.156 1.296.128a4.021 4.021 0 003.73-3.731c.03-.45-.017-.886-.127-1.296zM10 4c.955 0 1.888.131 2.79.382l-1.754 1.754a4.03 4.03 0 00-1.297-.128 4.009 4.009 0 00-3.603 5.027L3.42 13.751c-1.198-.875-2.296-1.982-3.265-3.277a.804.804 0 010-.952C2.714 6.104 6.18 4 10 4z"
  })));
}

export default SvgLoginPassHiddenSv;